import useAiChatRepo from '@/composables/ai-chat/ai-chat-repo';
import useSnackBar from '@/composables/snackbar';
import { computed } from 'vue';
import { isPinned } from '@/lib/ai-chat-list';
import { logCatch } from '@/lib/logger/logger';

export default function useAiChatPin(chat) {
  const snackbar = useSnackBar();
  const { togglePin } = useAiChatRepo();

  const pinned = computed(() => isPinned(chat.value));
  const toggle = () => {
    if (!chat.value) {
      return Promise.resolve();
    }

    return togglePin(chat.value).catch(logCatch(() => { snackbar.error(); }));
  };

  return { pinned, toggle };
}
